
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
  components: {
    XHeader,
    Tabbar,
    TabbarItem,
    Cell
  },
  data () {
    return {
      pageTitle: '',
      userName: false,
      baseUrl: this.$store.state.url,
      tabList: [],
      maskStatus: false // 遮罩层
    }
  },
  mounted () {
    if (this.$route.query.isJump) { // 点击推送，跳入详情页
      console.log('跳转', this.$route.query)
      this.baseUrl = this.$route.query.hostAddress
      debugger
      this.$store.commit('setStateVal', {
        url: this.baseUrl,
        token: this.$route.query.token,
        userName: this.$route.query.account
      })
    }

    if (this.$store.state.userInfo.accounts) {
      this.userName = this.$store.state.userInfo.accounts
    }

    this.$store.state.todoTabType = ''// 待办页 默认打开合同tab
    this.$vux.loading.show({
      text: '加载中'
    })
    this.axios({
      url: this.baseUrl + '/wechat/todo/personal', // 打开待办页，默认显示‘合同’
      method: 'get'
    }).then((response) => {
      let dataArr = response.data.list
      this.tabList = dataArr
      this.$vux.loading.hide()
    }).catch((response) => {
      this.$vux.loading.hide()
    })
  },
  methods: {
    goLogin () {
      this.$router.push({ name: 'Login' })
    },
    goHome () {
      this.$router.push({ name: 'Home' })
    },
    goDone () {
      this.$router.push({ name: 'Done' })
    },
    todoTrigger () {
      this.maskStatus = false
    },
    launchTrigger () {
      this.maskStatus = false
      this.$router.push({ name: 'Launch' })
      // this.$common.notFound();
    },
    processTrack () {
      if (this.maskStatus === true) {
        this.maskStatus = false
      } else {
        this.maskStatus = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Ecms.vue